import { DownloadOutlined } from '@ant-design/icons';
import { Alert, Button, Form, FormInstance, FormItemProps, message, Modal, Space } from 'antd';
import * as React from 'react';
import AAUserApiService from '../../api/AAUserApiService';
import Routes from '../../config/Routes';
import * as AAUserImporterHandler from '../../handlerModels/AAUserImporterHandler';
import BaseFormProps from '../../redux/bases/BaseFormProps';
import BaseFormState from '../../redux/bases/BaseFormState';
import FileDownload from '../../utils/FileDownload';
import FileUploadUtil from '../../utils/FileUploadUtil';
import FormUtil from '../../utils/FormUtil';
import ValidationUtil from '../../utils/ValidationUtil';
import FileUpload from '../FileUpload';

interface AAUserImporterProps extends BaseFormProps {
  isInModal?: boolean;
  onSubmit?: (errors?: string[]) => void
}

interface AAUserImporterState extends BaseFormState {
}

class AAUserImporter extends React.Component<AAUserImporterProps, AAUserImporterState> {
  private readonly _formRef = React.createRef<FormInstance>();
  private getFormItems = () => {
    return new Map<string, FormItemProps>()
      .set(AAUserImporterHandler.Request.file, {
        name: AAUserImporterHandler.Request.file,
        label: 'Please select a file to import AA Users',
      });
  }

  constructor(props: AAUserImporterProps) {
    super(props);

    this.state = {
    };
  }

  private resetForm = () => {
    this._formRef.current?.resetFields();
  }

  public confirmImport = () => {
    const model = this._formRef.current?.getFieldsValue() ?? {} as AAUserImporterHandler.Request;
    Modal.confirm({
      title: 'Import Data',
      content: 'Importing this file will deactivate any accounts not included in the file.',
      onOk: () => this.handleSubmit(model),
      width: 500
    });
  }

  public handleSubmit = (model: any) => {
    this.setState({ submitting: true });

    if (!FormUtil.canSubmit(this._formRef, this.getFormItems())) {
      message.error('Please fill out all required fields.');
      this.setState({ loading: false, submitting: false });
    }

    else {
      const file = model.file.newFiles[0];
      const request = FileUploadUtil.attachFileToModel('aaUserImporter', {}, AAUserImporterHandler.Request.file, file)
      this.setState({ loading: true });

      AAUserApiService.aaUserImporter(request)
        .then((result: AAUserImporterHandler.Result) => {
          this.resetForm();
          this.setState({ submitting: false });
          const fileName = 'AA User Summary Report.xlsx';
          FileDownload.downloadBase64StringAsExcel(fileName, result ?? undefined);
        }).catch(() => {
          this.setState({ error: true })
        }).finally(() => {
          this.setState({ loading: false });
          if (this.props.onSubmit) {
            this.props.onSubmit([]);
          }
        });
    }
  }

  public downloadTemplate = () => {
    window.open(Routes.generateFull(Routes.AA_USER_IMPORT_TEMPLATE, {}, {}), '_blank')
  }

  render() {
    return (
      <Space direction="vertical">
        <Form layout='vertical' onFinish={this.handleSubmit} ref={this._formRef}>
          <Space direction="vertical">
            <Form.Item
              {...this.getFormItems().get(AAUserImporterHandler.Request.file)}
              {...ValidationUtil.getValidation(AAUserImporterHandler.Request.file, this.state.fieldErrors, this.state.submitted)}>
              <FileUpload maxCount={1} style={{ width: 300 }} />
            </Form.Item>
            {this.props.isInModal ? null :
              <Button
                htmlType='submit'
                type='primary'
                loading={this.state.loading} >Import</Button>}
            <Button icon={<DownloadOutlined />} type='link' onClick={this.downloadTemplate}>Download Template</Button>
            {this.renderErrors()}
          </Space>
        </Form>
      </Space>
    );
  }

  renderErrors() {
    if (this.state.error && this.state.message) {
      return <Alert type="error" message='Error' showIcon={true} description={this.state.message} />;
    }
  }
}

export default AAUserImporter;
